import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

import { useTranslation } from "~/i18n";

export function SurveyDetailBackLink() {
  const { t } = useTranslation();

  return (
    <Link
      to="/surveys"
      className="inline-flex min-h-11 items-center gap-2 rounded-md border border-border bg-surface px-3 py-2 text-sm font-bold text-foreground transition-colors hover:bg-canvas focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand active:bg-border/60 motion-reduce:transition-none"
    >
      <ArrowLeft
        aria-hidden="true"
        className="size-5 stroke-[2.5] text-muted"
      />
      <span>{t("surveyDetail.backToSurveys")}</span>
    </Link>
  );
}
